"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _url = require("url");
var _react = _interopRequireWildcard(require("react"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _Popover = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Popover"));
var _classnames = _interopRequireDefault(require("classnames"));
var _PillLink = _interopRequireDefault(require("../../PillLink"));
var _EditableCategories = _interopRequireDefault(require("../../EditableCategories"));
var _EmptyMetadataEditMode = _interopRequireDefault(require("../EmptyMetadataEditMode"));
var _events = require("../events");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var ArrowIcon = function ArrowIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.293 9.293a1 1 0 0 1 1.414 0l4.288 4.288 4.299-4.289a1 1 0 0 1 1.412 1.416l-4.299 4.29c-.781.78-2.044.78-2.824 0l-4.29-4.29a1 1 0 0 1 0-1.415z"
  }));
};
ArrowIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var CategoriesIcon = function CategoriesIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0a2 2 0 0 0-2 2v12.5A1.5 1.5 0 0 0 1.5 16h17a1.5 1.5 0 0 0 1.5-1.5v-11A1.5 1.5 0 0 0 18.5 2H10L8 0H2Zm-.5 14.5v-11h17v11h-17Z"
  }));
};
CategoriesIcon.defaultProps = {
  viewBox: "0 0 20 16",
  xmlns: "http://www.w3.org/2000/svg"
};
var styles = {
  "icon": "CustomerMetadata__icon__1eFWZ",
  "dropdown-icon": "CustomerMetadata__dropdown-icon__1fowq",
  "dropdownIcon": "CustomerMetadata__dropdown-icon__1fowq",
  "metadata-item": "CustomerMetadata__metadata-item__1rfCM",
  "metadataItem": "CustomerMetadata__metadata-item__1rfCM",
  "metadata-item-wrapper": "CustomerMetadata__metadata-item-wrapper__6kwbv",
  "metadataItemWrapper": "CustomerMetadata__metadata-item-wrapper__6kwbv",
  "extendable": "CustomerMetadata__extendable__GmS9B",
  "editable": "CustomerMetadata__editable__2RE1j",
  "metadata": "CustomerMetadata__metadata__2OWHW",
  "popover": "CustomerMetadata__popover__ozLWy",
  "metadata-row": "CustomerMetadata__metadata-row__38kip",
  "metadataRow": "CustomerMetadata__metadata-row__38kip"
}; 
require('../CustomerMetadata.css');
var categoryStyles = {
  "container": "Categories__container__vRZVo",
  "categories": "Categories__categories__9maXh",
  "select": "Categories__select__xEE9z",
  "category": "Categories__category__R38yY",
  "name": "Categories__name__3bk3N",
  "values": "Categories__values__2oHzN",
  "pill": "Categories__pill__22MBq",
  "pill-span": "Categories__pill-span__2GSes",
  "pillSpan": "Categories__pill-span__2GSes"
}; 
require('./Categories.css');
var BOTTOM_LEFT_POSITION = 'bl';
var DOWN_POSITION = 'd';
var hideMetadataContent = function hideMetadataContent(organizationCategories, asset, canEdit) {
  var _asset$categories, _asset$categories2;
  return !(organizationCategories !== null && organizationCategories !== void 0 && organizationCategories.length) && !((_asset$categories = asset.categories) !== null && _asset$categories !== void 0 && _asset$categories.length) || !((_asset$categories2 = asset.categories) !== null && _asset$categories2 !== void 0 && _asset$categories2.length) && !canEdit;
};
var Categories = function Categories(_ref) {
  var _ref$canEdit = _ref.canEdit,
    canEdit = _ref$canEdit === void 0 ? false : _ref$canEdit,
    asset = _ref.asset,
    organizationCategories = _ref.organizationCategories;
  var trackEvent = (0, _exchangeReactHooks.useAnalyticsTracking)();
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isSelectOpen = _useState2[0],
    setIsSelectOpen = _useState2[1];
  var getPath = (0, _exchangeReactHooks.useGetPath)();
  var getCategoryURL = function getCategoryURL(categoryValue, category) {
    var categoryName = category.key;
    var pathname = getPath('home');
    var query = {
      search: "category:\"".concat(categoryName, "\" = \"").concat(categoryValue, "\""),
      show: 'all'
    };
    return (0, _url.format)({
      pathname: pathname,
      query: query
    });
  };
  var renderPopoverModal = function renderPopoverModal() {
    if (canEdit) {
      return /*#__PURE__*/_react.default.createElement(_EditableCategories.default, {
        asset: asset,
        onToggleSelect: function onToggleSelect(isOpen) {
          return setIsSelectOpen(isOpen);
        }
      });
    }
    return /*#__PURE__*/_react.default.createElement("section", {
      "data-test-id": "view-asset-categories",
      className: categoryStyles.container
    }, /*#__PURE__*/_react.default.createElement("h2", {
      id: "categories-heading",
      className: "visually-hidden"
    }, "Categories"), /*#__PURE__*/_react.default.createElement("div", {
      className: categoryStyles.categories
    }, asset.categories.map(function (category) {
      var _category$value;
      return /*#__PURE__*/_react.default.createElement("div", {
        "data-test-id": "view-asset-category",
        className: categoryStyles.category,
        key: "category-".concat(category.key, "-").concat((_category$value = category.value) === null || _category$value === void 0 ? void 0 : _category$value.length)
      }, /*#__PURE__*/_react.default.createElement("div", {
        "data-test-id": "view-asset-category-name",
        className: categoryStyles.name
      }, /*#__PURE__*/_react.default.createElement("span", null, category.displayName)), /*#__PURE__*/_react.default.createElement("div", {
        className: categoryStyles.values,
        "aria-live": "polite"
      }, (category.value || []).map(function (value) {
        return /*#__PURE__*/_react.default.createElement(_PillLink.default, {
          key: "category-".concat(value),
          to: getCategoryURL(value, category),
          title: value,
          "aria-label": "Go to category ".concat(value),
          disabled: true
        }, value);
      })));
    })));
  };
  var popoverContainer = _react.default.useRef(null);
  var renderMetadataContent = function renderMetadataContent() {
    var _asset$categories3;
    if (hideMetadataContent(organizationCategories, asset, canEdit)) {
      return null;
    }
    if (canEdit && !((_asset$categories3 = asset.categories) !== null && _asset$categories3 !== void 0 && _asset$categories3.length) && organizationCategories !== null && organizationCategories !== void 0 && organizationCategories.length) {
      return /*#__PURE__*/_react.default.createElement(_EmptyMetadataEditMode.default, {
        metadataType: "categories"
      });
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      "data-test-id": "categories-metadata-item-test",
      className: (0, _classnames.default)(styles.metadataItemWrapper, styles.extendable)
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      className: styles.icon,
      "aria-hidden": true
    }, /*#__PURE__*/_react.default.createElement(CategoriesIcon, null)), /*#__PURE__*/_react.default.createElement("span", {
      className: styles.metadataItem,
      id: "categories-metadata-item"
    }, "Categories (".concat(asset.categories.length, ")")), /*#__PURE__*/_react.default.createElement(_Icon.default, {
      "data-test-id": "drowpdown-arrow-icon",
      className: styles.dropdownIcon,
      size: "xs"
    }, /*#__PURE__*/_react.default.createElement(ArrowIcon, null)));
  };
  if (hideMetadataContent(organizationCategories, asset, canEdit)) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-test-id": "categories-container",
    ref: popoverContainer
  }, /*#__PURE__*/_react.default.createElement(_Popover.default, {
    onOpen: function onOpen() {
      return trackEvent(_events.EVENT_TYPES.EXPANDING_CATEGORIES);
    },
    anchorPosition: BOTTOM_LEFT_POSITION,
    popupPosition: DOWN_POSITION,
    getPopoverContainer: function getPopoverContainer() {
      return popoverContainer === null || popoverContainer === void 0 ? void 0 : popoverContainer.current;
    },
    content: renderPopoverModal(),
    closeOnClickOutside: !isSelectOpen
  }, renderMetadataContent()));
};
var _default = exports.default = Categories;
//# sourceMappingURL=Categories.js.map